/**
 * InputBase Component
 *
 * Abstraction layer over MUI InputBase.
 * Used for custom input implementations.
 */

import { InputBase as MuiInputBase, InputBaseProps } from '@mui/material';
import React from 'react';

const InputBase = React.forwardRef<HTMLDivElement, InputBaseProps>((props, ref) => {
  return <MuiInputBase ref={ref} {...props} />;
});

InputBase.displayName = 'InputBase';

export default InputBase;
